
export default {
  DEFAULT_PER_PAGE: 10,
  ADMIN_FIELDS: [
    {email: 'Email'},
    {name: '姓名'},
    {remark: '部门'},
    {admin_type: '管理员类型'},
    {admin_op: '操作'}
  ],
  SERVICE_PERM_FIELDS: [
    {service_code: '服务'},
    {show_details: '产品权限'}
  ],
  PRODUCT_FIELDS: [
    {name: '产品名'},
    {code: '产品代号'}
  ],
  ADMIN_TYPES: [
    {value: null, text: '请选择', disabled: true}
  ],
  SERVICE_TYPES: [
    {value: null, text: '请选择', disabled: true},
    {value: 'auto', text: '自动部署'},
    {value: 'manual', text: '人工部署'}
  ],
  CATEGORY_TYPES: [
    {value: null, text: '请选择', disabled: true}
  ],
  SERVICE_FIELDS: [
    {name: '服务名'},
    {code: '代号'},
    {type: '创建实例方式'},
    {acl_token: '密钥'},
    {app: '操作'}
  ],
  APP_FIELDS: [
    {code: '实例代号'},
    {name: '实例名'},
    {product_code: '产品名'},
    {tags: '标签'},
    {detail: '操作'}
  ],
  PROJECT_FIELDS: [
    {name: '实例名'},
    {product_code: '产品名'},
    {detail: '操作'}
  ],
  DEMO_FIELDS: [
    {code: '实例代号'},
    {name: '实例名'},
    {product_code: '产品名'},
    {service_code: '服务名'},
    {detail: '操作'}
  ],
  ACCEPT_TYPES: 'image/jpeg, image/png',
  FP_TYPE: 'image',
  DEFAULT_IMG_URL: '/static/img/default-img.png',
  TAG_FIELDS: [
    {tag: '标签代号'},
    {name: '标签名'},
    {service_code: '服务代号'},
    {product_code: '产品代号'},
    {app_code: '实例代号'},
    {detail: '操作'}
  ],
  GROUP_FIELDS: [
    {_id: '分组ID'},
    {name: '分组名'},
    {detail: '操作'}
  ],
  APP_STATUS: [
    {value: null, text: '请选择', disabled: true}
  ],
  PERM_BIT: {
    superAdmin: 0,
    confRead: 4,
    confWrite: 5
  },
  ROLE_FIELDS: [
    {_id: '角色ID'},
    {name: '角色名'},
    {role_op: '操作'}
  ],
  VOTE_FIELDS: [
    {app_id: '实例ID'},
    {app_name: '实例标题'},
    {creator_urs: '创建者'},
    {vote_op: '操作'}
  ],
  VOTE_RADIO_JUDGE_OPTIONS: [
    { text: '是', value: true },
    { text: '否', value: false }
  ],
  VOTE_LOGIN_CONFIG_OPTIONS: [
    { text: '网易通行证', value: 2 },
    { text: '手机', value: 4, oversea: false },
    { text: '微信', value: 16, oversea: false },
    { text: '微博', value: 32, oversea: false },
    { text: 'QQ', value: 64, oversea: false },
    // { text: '微信小程序', value: 128, oversea: false },
    // { text: 'QQ小程序', value: 256, oversea: false },
    { text: 'Facebook', value: 512, oversea: true },
    { text: 'Twitter', value: 1024, oversea: true }
    // { text: 'Line', value: 2048, oversea: true }
  ],
  VOTE_DETAIL_LOGIN_CONF: {
    urs: {
      login_typ: 2,
      login_base_num: 1,
      text: '网易通行证',
      conf_name: '',
      conf: []
    },
    mobile: {
      login_typ: 4,
      login_base_num: 2,
      text: '手机短信',
      conf_name: 'login_mobile_config',
      conf: [
        { text: '产品名', sm: 2, conf_key: 'PRODUCT' },
        { text: '计费通道', sm: 2, conf_key: 'COST_GATEWAY' },
        { text: '短信内容', sm: 6, conf_key: 'MSG' }
      ]
    },
    weixin: {
      login_typ: 16,
      login_base_num: 4,
      text: '微信',
      conf_name: 'login_wx_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'weixin_id' },
        { text: '密钥', sm: 5, conf_key: 'weixin_secret' }
      ]
    },
    weibo: {
      login_typ: 32,
      login_base_num: 5,
      text: '微博',
      conf_name: 'login_weibo_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'weibo_id' },
        { text: '密钥', sm: 5, conf_key: 'weibo_secret' }
      ]
    },
    qq: {
      login_typ: 64,
      login_base_num: 6,
      text: 'QQ',
      conf_name: 'login_qq_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'qq_id' },
        { text: '密钥', sm: 5, conf_key: 'qq_secret' }
      ]
    },
    weixin_mp: {
      login_typ: 128,
      login_base_num: 7,
      text: '微信小程序',
      conf_name: 'login_wx_mp_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'weixin_mp_id' },
        { text: '密钥', sm: 5, conf_key: 'weixin_mp_secret' }
      ]
    },
    qq_mp: {
      login_typ: 256,
      login_base_num: 8,
      text: 'QQ小程序',
      conf_name: 'login_qq_mp_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'qq_mp_id' },
        { text: '密钥', sm: 5, conf_key: 'qq_mp_secret' }
      ]
    },
    facebook: {
      login_typ: 512,
      login_base_num: 9,
      text: 'Facebook',
      conf_name: 'login_facebook_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'facebook_id' },
        { text: '密钥', sm: 5, conf_key: 'facebook_secret' }
      ]
    },
    twitter: {
      login_typ: 1024,
      login_base_num: 10,
      text: 'Twitter',
      conf_name: 'login_twitter_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'twitter_key' },
        { text: '密钥', sm: 5, conf_key: 'twitter_secret' }
      ]
    },
    line: {
      login_typ: 2048,
      login_base_num: 11,
      text: 'Line',
      conf_name: 'login_line_config',
      conf: [
        { text: '令牌', sm: 5, conf_key: 'line_app_id' },
        { text: '密钥', sm: 5, conf_key: 'line_app_secret' }
      ]
    }
  },
  VOTE_DEFAULT_TABLE_CONFIG: [
    { text: '字段名', field: 'field', default: '', tag: 'input', required: false },
    { text: '字段类型', field: 'type', default: '', tag: 'select', required: false },
    { text: '字段长度', field: 'field_len', default: '10', tag: 'input', required: false },
    { text: '是否为空', field: 'null', default: true, tag: 'radio', required: true },
    { text: '默认值', field: 'default', default: '', tag: 'input', required: false },
    { text: '操作', field: '', default: '', tag: '' }
  ],
  VOTE_TABLE_SELECT_OPTIONS: {
    type: [
      { text: 'INT', value: 'int' },
      { text: 'DECIMAL', value: 'decimal' },
      { text: 'FLOAT', value: 'float' },
      { text: 'DOUBLE', value: 'double' },
      { text: 'BIGINT', value: 'bigint' },
      { text: 'TINYINT', value: 'tinyint' },
      { text: 'BOOLEAN', value: 'bool' },
      { text: 'VARCHAR', value: 'varchar' },
      { text: 'CHAR', value: 'char' },
      { text: 'TEXT', value: 'text' },
      { text: 'DATETIME', value: 'datetime' },
      { text: 'TIMESTAMP', value: 'timestamp' },
      { text: 'JSON', value: 'json' },
      { text: 'BLOB', value: 'BLOB' }
    ]
  },
  VOTE_DEFAULT_TABLE_CONFIG_VAL: { field: '', type: '', field_len: null, null: true, default: '', auto_increment: false },
  VOTE_PULL_CONFIG_PARAMS: [
    { text: 'URL', field: 'url', tag: 'input', placeholder: '', description: '', type: 'text', required: true },
    { text: '拉取方式', field: 'fetch_method', tag: 'select', description: '', required: true },
    { text: '签名加密方法', field: 'sign_method', tag: 'select', placeholder: '', description: '签名所用的加密方法，需要hashlib内支持的方法', required: true },
    { text: '使用hmac', field: 'is_hmac', tag: 'judge', required: true },
    { text: '签名方式', field: 'sign_type', tag: 'select', description: '签名方式为none时不需要签名，否则根据【验证参数】的key值顺序将值填入并计算签名；签名方式为strict模式时，若【验证参数】中有一个元素不存在，则会报错，default则不会', required: true },
    { text: '签名前缀', field: 'sign_par_name', tag: 'input', placeholder: '', description: '', type: 'text', required: true },
    { text: '拉取传参', field: 'param_set', tag: 'dynamic', description: '支持使用匿名函数获取当前时间之类的简单操作。如: "ts": "lambda: int(round(time.time()))"', required: true },
    { text: '验证字段', field: 'sign_params', tag: 'show_list', description: '需要验证完整性的参数，按【拉取传参】勾选顺序排列，若签名方式不为none则至少需要勾选一项', required: true },
    { text: '密钥', field: 'sign_key', tag: 'input', placeholder: '', description: '', type: 'text', required: true },
    { text: '拉取数据处理函数', field: 'fetch_ret_lambda', tag: 'input', description: '获取内容后执行的lambda函数，最后得到的数据格式应为：{ "succ":True, "result":[数据], "count":$(int)总数据个数，用于分页 }；若数据不是该格式，则通过该拉取函数处理成这种格式', type: 'text', required: false },
    { text: '接口拉取根据', field: 'pull_config_limit_config_id_page', external_field: 'id_page', tag: 'select_external', description: '', required: true },
    { text: '拉取根据的Key名', field: 'pull_config_limit_config_id_par_name', external_field: 'id_par_name', tag: 'input_external', placeholder: '', description: '若不需要/不支持分页拉取，可不填', type: 'text', required: false },
    { text: '起始ID/页标', field: 'pull_config_limit_config_start', external_field: 'start', tag: 'input_external', placeholder: '', description: '', type: 'number', required: true },
    { text: '结束ID/页标', field: 'pull_config_limit_config_end', external_field: 'end', tag: 'input_external', placeholder: '', description: '', type: 'number', required: true },
    { text: '单页拉取数量', field: 'pull_config_limit_config_per_num', external_field: 'per_num', tag: 'input_external', placeholder: '', description: '', type: 'number', required: true },
    { text: '平均每页拉取条数的Key名', field: 'pull_config_limit_config_per_num_par_name', external_field: 'per_num_par_name', tag: 'input_external', placeholder: '', description: '若不需要/不支持分页拉取，可不填', type: 'text', required: false }
  ],
  VOTE_YIDUN_CONFIG_PARAMS: [
    { text: 'businessId', field: 'businessId', placeholder: '业务ID', description: '', type: 'text', required: true },
    { text: 'secretId', field: 'secretId', placeholder: '密钥ID', description: '', type: 'text', required: true },
    { text: 'secretKey', field: 'secretKey', placeholder: '密钥KEY', description: '', type: 'text', required: true }
  ],
  VOTE_PULL_CONFIG_SELECT_OPTIONS: {
    fetch_method: [
      { text: 'GET', value: 'GET' },
      { text: 'POST', value: 'POST' }
    ],
    sign_type: [
      { text: 'none', value: 'none' },
      { text: 'default', value: 'default' },
      { text: 'strict', value: 'strict' }
    ],
    pull_config_limit_config_id_page: [
      { text: 'ID', value: true },
      { text: '页标', value: false }
    ],
    sign_method: [
      { text: 'md5', value: 'md5' },
      { text: 'sha1', value: 'sha1' },
      { text: 'sha224', value: 'sha224' },
      { text: 'sha256', value: 'sha256' },
      { text: 'sha384', value: 'sha384' },
      { text: 'sha512', value: 'sha512' }
    ]
  },
  VOTE_PULL_CONFIG_PARAMS_SET: [
    { text: '键', field: 'key', tag: 'input' },
    { text: '值', field: 'value', tag: 'input' },
    { text: '是否需要验证', field: 'check', tag: 'check' },
    { text: '操作', field: '', tag: '' }
  ],
  VOTE_DEFAULT_PULL_CONFIG_PARAMS_SET_VAL: { key: '', value: '', check: false },
  VOTE_LIMIT_CONFIG_PARAMS: [
    { text: '单个用户总投票数', field: 'limit_vote_num', tag: 'input', description: '', type: 'number', placeholder: '', required: true },
    { text: '限制方式（可多选或不选）', field: 'is_limit', tag: 'checkbox', description: '' },
    { text: '对IP限制访问的单位时间（单位：秒）', field: 'IP_limit_time', tag: 'condition-input', description: '若限制方式包含IP，则必填', type: 'number', placeholder: '', required: 2 },
    { text: '单位时间内IP限制访问次数', field: 'IP_limit_num', tag: 'condition-input', description: '若限制方式包含IP，则必填', type: 'number', placeholder: '', required: 2 },
    { text: '对用户限制投票的单位时间', field: 'every', tag: 'condition-radio', description: '若限制方式包含用户，则必填', required: 1 },
    { text: '单位时间内用户投票次数', field: 'user_limit_num', tag: 'condition-input', description: '若限制方式包含用户，则必填，不限则填"-1"', type: 'number', placeholder: '', required: 1 },
    { text: '单位时间内用户对投票项的投票次数', field: 'user_item_limit_num', tag: 'condition-input', description: '若限制方式包含用户，则必填，不限则填"-1"', type: 'number', placeholder: '', required: 1 }
  ],
  VOTE_LIMIT_CONFIG_OPTIONS: {
    is_limit: [
      { text: 'IP', value: 2 },
      { text: '用户', value: 1 }
    ],
    every: [
      { text: '全局限制', value: 0 },
      { text: '每天', value: 3 },
      { text: '每小时', value: 4 }
    ]
  },
  VOTE_ENABLE_EDIT_FIELDS: [
    'app_name', 'login_conf', 'is_pull', 'pull_config', 'limit_config', 'ins_start_time', 'ins_end_time',
    'yidun_config', 'bind_config', 'extra_login'
  ],
  VOTE_ITEM_STATIC_FIELDS_1: [
    { vote_id: 'vote_id' },
    { vote: '票数' },
    { online: '是否上线' }
  ],
  VOTE_ITEM_STATIC_FIELDS_2: [
    { last_modified: '最后修改时间' },
    { item_op: '操作' }
  ],
  VOTE_ITEM_LIMIT_CONFIG_FIELDS: [
    { text: '是否限制用户投票', field: 'is_limit', tag: 'judge', required: true },
    { text: '对用户限制投票的单位时间', field: 'every', tag: 'radio', required: false },
    { text: '单位时间内用户投票次数', field: 'user_limit_num', tag: 'input', type: 'number', placeholder: '', required: false },
    { text: '单位时间内用户对投票项的投票次数', field: 'user_item_limit_num', tag: 'input', type: 'number', placeholder: '', required: false },
    { text: '开始时间', field: 'limit_start_time', tag: '', type: 'text', placeholder: '%Y-%m-%d-%H-%M-%s', required: true },
    { text: '结束时间', field: 'limit_end_time', tag: '', type: 'text', placeholder: '%Y-%m-%d-%H-%M-%s', required: true }
  ],
  SQL_TYPE_DICT: {
    varchar: {
      tag: 'input',
      type: 'text'
    },
    int: {
      tag: 'input',
      type: 'number'
    },
    float: {
      tag: 'input',
      type: 'number'
    },
    double: {
      tag: 'input',
      type: 'number'
    },
    boolean: {
      tag: 'judge'
    }
  },
  VOTE_AUTH_FIELDS: [
    {name: '姓名'},
    {op: '操作'}
  ],
  VOTE_REWARD_FIELDS: [
    {id: 'ID'},
    {vote_number: '用户累计投票数'},
    {reward_type: '是否限量'},
    {prize: '奖励（序列号或虚拟奖励，可输入多个奖励）'},
    {receive_num: '可领个数'},
    {op: '操作'}
  ],
  VOTE_REWARD_BASE_DATA: {
    vote_number: null,
    reward_type: null,
    prize: [
      { name: '', number: '' }
    ],
    receive_num: 1,
    disabled: false,
    new: true,
    value: ''
  },
  VOTE_USER_REWARD_FIELDS: [
    {index: '#'},
    {reward_id: '奖励项ID'},
    {prize: '奖励内容'},
    {create_time: '领奖时间'}
  ],
  VOTE_FIELD_NAME: {
    app_name: '实例标题',
    login_conf: '登陆方式',
    is_login_need: '是否需要登录',
    login_way: '登录方式',
    table_config: '数据表配置',
    fields: '数据表字段',
    unique_keys: '唯一索引',
    index: '索引',
    is_pull: '是否拉取投票项',
    pull_config: '拉取配置',
    param_set: '拉取传参',
    sign_params: '验证字段',
    start: '起始ID/页标',
    end: '结束ID/页标',
    id_page: '接口拉取根据',
    per_num: '单页拉取数量',
    id_par_name: '拉取根据的Key名',
    per_num_par_name: '平均每页拉取条数的Key名',
    fetch_method: '拉取方式',
    sign_type: '签名方式',
    sign_method: '签名加密方法',
    sign_key: '密钥',
    sign_par_name: '签名前缀',
    url: 'url',
    is_hmac: '是否使用hmac',
    fetch_ret_lambda: '拉取数据处理函数',
    limit_config: '投票限制',
    is_limit: '限制方式',
    limit_vote_num: '单个投票项投票次数',
    IP_limit_time: '对IP限制访问的单位时间',
    IP_limit_num: '单位时间内IP限制访问次数',
    every: '对用户限制投票的单位时间',
    user_limit_num: '单位时间内用户投票次数',
    user_item_limit_num: '单位时间内用户对投票项的投票次数',
    limit_start_time: '开始时间',
    limit_end_time: '结束时间',
    ins_start_time: '实例开始时间',
    ins_end_time: '实例结束时间'
  },
  TABLE_EMPTY_TEXT: '暂无数据',
  LIMIT_CONFIG_TEXT: {
    '-1': '不限制',
    '0': '全局限制',
    '1': '每年',
    '2': '每月',
    '3': '每天',
    '4': '每小时'
  },
  VOTE_STATISTICS_FIELDS: [
    {data_date: '日期'},
    {total_vote: '总票数'},
    {total_vote_monthly: '月总票数'},
    {daily_new_user: '日新增投票用户'}
  ],
  VOTE_ITEM_STATISTICS_FIELDS: [
    {vote_id: 'Vote id'},
    {vote: '票数'},
    {online: '上线'}
  ],
  VOTE_USER_ALL_FIELDS: [
    {vote_id: 'Vote id'},
    {option_id: '子投票项'},
    {user_name: '投票者'},
    {time: '投票时间'}
  ],
  VOTE_USER_SINGLE_FIELDS: [
    {vote_id: 'Vote id'},
    {option_id: '子投票项'},
    {time: '投票时间'}
  ],
  VOTE_ITEM_DETAIL_FIELDS: [
    {user_name: '投票者'},
    {time: '投票时间'},
    {option_id: '子投票项'}
  ],
  VOTE_ITEM_TOP_FIELDS: [
    {top_id: 'Vote id'},
    {top_num: '票数'}
  ],
  VOTE_USER_LOGIN_TYPES: {
    0: '免登录',
    1: '网易通行证',
    2: '手机',
    4: '微信',
    5: '微博',
    6: 'QQ',
    7: '微信小程序',
    8: 'QQ小程序',
    9: 'Facebook',
    10: 'Twitter',
    11: 'Line',
    99: '外部登录'
  },
  WELCOME_CATEGORY_FIELDS: [
    {name: '分类名称'},
    {code: '代号'},
    {icon: '图标'},
    {sortId: '排位'},
    {op: '操作'}
  ],
  WELCOME_SERVICE_FIELDS: [
    {name: '服务名称'},
    {code: '代号'},
    {sortId: '排位'},
    {category_name: '分类'},
    {op: '操作'}
  ],
  WELCOME_DEMO_FIELDS: [
    {name: '样例名称'},
    {code: '代号'},
    {sortId: '排位'},
    {op: '操作'}
  ],
  BRIEF_OPTIONS: [
    { value: true, text: 'Markdown' },
    { value: false, text: 'HTML' }
  ],
  UPLOAD_FILE_PLACEHOLDER: '点击上传文件，请选择包含html内容的文件',
  UPLOAD_FILE_BROWSE_TEXT: '选择文件',
  OVERSEA_TYPE: 'oversea',
  VOTE_BIND_CONFIG_OPTIONS: [
    { text: '手机', value: 2 }
  ],
  VOTE_DETAIL_BIND_CONF: {
    phone: {
      bind_typ: 2,
      bind_base_num: 1,
      text: '手机',
      conf_name: 'phone',
      conf: [
        { text: '产品名', sm: 2, conf_key: 'PRODUCT' },
        { text: '计费通道', sm: 2, conf_key: 'COST_GATEWAY' },
        { text: '短信内容', sm: 6, conf_key: 'MSG' }
      ]
    }
  },
  VOTE_DETAIL_LIMIT_CONF: {
    ip: {
      type: 2,
      text: 'IP',
      conf: [
        { text: '对IP限制访问的单位时间（单位：秒）：', conf_key: 'IP_limit_time', extra_key: true },
        { text: '单位时间内IP限制访问次数：', conf_key: 'IP_limit_num', extra_key: true }
      ]
    },
    user: {
      type: 1,
      text: '用户',
      conf: [
        { text: '对用户限制投票的单位时间：', conf_key: 'every', extra_key: false },
        { text: '单位时间内用户投票次数：', conf_key: 'user_limit_num', extra_key: true },
        { text: '单位时间内用户对投票项的投票次数：', conf_key: 'user_item_limit_num', extra_key: true }
      ]
    }
  },
  overseaTag: '（海外版）'
}



// WEBPACK FOOTER //
// ./src/utils/consts.js